<template>
  <div>
    <page-header :title="$t('scope.text_797')" />
    <page-body>
      <license-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import LicenseList from './components/List'

export default {
  name: 'License',
  components: {
    LicenseList,
  },
  data () {
    return {
      listId: 'licenseList',
    }
  },
}
</script>
